import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

/** min-h-11 keeps every button at the 44px accessible tap target. */
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-600 active:scale-[0.98]',
  secondary: 'bg-surface-2 text-content hover:bg-line active:scale-[0.98]',
  ghost: 'bg-transparent text-muted hover:bg-surface-2',
  danger: 'bg-danger text-white active:scale-[0.98]',
};

export function Button({ variant = 'primary', className = '', children, ...rest }: ButtonProps) {
  return (
    <button
      className={`inline-flex min-h-11 items-center justify-center gap-2 rounded-[var(--radius-btn)] px-5 text-[15px] font-semibold transition-all duration-[120ms] disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
